import { TableItemActionsNew, Icons } from 'components';

const columns = (
  setDialog,
  closeTicketRequest,
  cancelTicketRequest,
  redirectToDetails,
  actionsList
) => [
    {
      title: 'ردیف',
      field: 'num',
      filtering: false,
      sorting: false,
      align: 'center',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
    },
    {
      title: 'شناسه درخواست',
      field: 'PId',
      filtering: false,
      sorting: false,
      align: 'center',
    },
    {
      title: 'تاریخ ایجاد',
      field: 'CreationDatePersian',
      filtering: false,
      sorting: false,
      dir: 'ltr',
      align: 'center',
    },
    {
      title: 'موضوع',
      field: 'Name',
      filtering: false,
      sorting: false,
      align: 'center',
    },
    {
      title: 'نام نویسنده',
      field: 'UserInfo.Name',
      filtering: false,
      sorting: false,
      align: 'center',
      render: (row) => (row?.UserInfo ? row?.UserInfo.Name : '-'),

    },
    {
      title: 'فایل‌ پیوست',
      field: 'AttachmentInfo',
      filtering: false,
      sorting: false,
      align: 'center',
      render: (row) => (row?.AttachmentInfo?.length ? 'دارد' : 'ندارد'),
    },
    {
      title: 'وضعیت',
      field: 'TicketStatus',
      filtering: false,
      sorting: false,
      align: 'center',
    },
    ...(actionsList['contentTicketListDetailSalePage'] ||
      actionsList['contentTicketListCloseSalePage'] ||
      actionsList['contentTicketListCancelSalePage'] ? [{
        title: 'عملیات',
        field: '',
        filtering: false,
        sorting: false,
        align: 'right',
        cellStyle: {
          width: '1%',
        },
        headerStyle: {
          width: '1%',
        },
        render: (rowData) => (
          <TableItemActionsNew
            iconButton
            startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
            title=""
            otherMenus={[
              {
                title: 'جزییات',
                isShow: !!actionsList['contentTicketListDetailSalePage'],
                onClick: () => redirectToDetails(rowData),
              },
              {
                title: 'لغو تیکت',
                isShow: !!actionsList['contentTicketListCancelSalePage'],
                disabled: (rowData?.StateInfo?.Name === "Close" || rowData?.StateInfo?.Name === "Reject") ? true : false,
                onClick: () => {
                  setDialog({
                    title: `  لغو تیکت ${rowData.Name} `,
                    content: 'آیا از لغو تیکت اطمینان دارید؟',
                    open: true,
                    onAccept: () => {
                      cancelTicketRequest(rowData);
                    },
                  });
                },
              },
              {
                title: 'بستن تیکت',
                isShow: !!actionsList['contentTicketListCloseSalePage'],
                disabled: (rowData?.StateInfo?.Name === "Reject" || rowData?.StateInfo?.Name === "Close") ? true : false,
                onClick: () => {
                  setDialog({
                    title: ` بستن تیکت ${rowData.Name} `,
                    content: 'آیا از بستن تیکت اطمینان دارید؟',
                    open: true,
                    onAccept: () => {
                      closeTicketRequest(rowData);
                    },
                  });
                },
              },
            ]}
          />
        ),

      }] : []),
  ]

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, generateData };